import Rank from './Rank';

export const models = {
    Rank,
};
